import { Paragraph, Table } from '@zillow/constellation-10';
import { IconNoteFilled } from '@zillow/constellation-icons';
import { format } from 'date-fns';
import { ModalType } from '../../../../types/ModalType';
import TriggerText from '../../../TriggerText';
import type { HandleOpenModal } from '../TableContent';
import {
  ADD_NOTE_ENTRY_CLICK_EVENT_TYPE_ID,
  emitAddNoteEntryClickEvent,
} from '../../../../constants/clickstreamEvents/multiFamilyLeadsPage';
import { useAuth } from '../../../../AuthProvider';

type Props = {
  hasNotes: boolean;
  lastUpdatedMs?: number | undefined | null;
  onAddNotesClick: HandleOpenModal;
};

export default function NotesTableCell({ hasNotes, lastUpdatedMs, onAddNotesClick }: Props) {
  const noteUpdatedTimestamp = lastUpdatedMs ? format(new Date(lastUpdatedMs), 'M/d/yy') : '';
  const { user } = useAuth();

  const handleAddNotesClick = () => {
    emitAddNoteEntryClickEvent(user);
    return onAddNotesClick(ModalType.NotesModal);
  };

  return (
    <Table.Cell css={{ verticalAlign: 'top' }}>
      <TriggerText
        data-eventid={ADD_NOTE_ENTRY_CLICK_EVENT_TYPE_ID}
        icon={<IconNoteFilled />}
        onClick={handleAddNotesClick}
      >
        {hasNotes ? 'View/add' : 'Add'}
      </TriggerText>

      {hasNotes && noteUpdatedTimestamp && (
        <Paragraph textStyle="body-xs" css={{ color: 'text.subtle', marginTop: 'tighter', whiteSpace: 'nowrap' }}>
          {`Updated ${noteUpdatedTimestamp}`}
        </Paragraph>
      )}
    </Table.Cell>
  );
}
